import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../../components/Hyperlink';

type Props = {
  className: string;
};

export class SignUpLinkToSignIn extends React.Component<Props> {
  render() {
    return (
      <div className={`signup-form__signin ${this.props.className}`}>
        <FormattedMessage id="signup/routes/user/form/SignUpLinkToSignIn.tsx/1" />{' '}
        <Hyperlink
          className="signup-form__signin__link"
          href="/connexion?source=signup"
        >
          <FormattedMessage id="signup/routes/user/form/SignUpLinkToSignIn.tsx/2" />
        </Hyperlink>
      </div>
    );
  }
}
